
<div>
  <configure-bookmark-folder-row
    :folder="folder"
  />
  <draggable v-model="folder.sortedBookmarkLinks" group="bookmarks" v-bind="VueDraggableDefinition.getOptions()"  @change="persistBookmarkLinkMove">
    <configure-bookmark-link-row
      v-for="link in folder.sortedBookmarkLinks"
      :key="link.id"
      :link="link"
      :folder="folder"
    />
  </draggable>
  <row>
    <column class="row-title">
      <button class="btn-link" @click="addLinkClicked">+ Add Link</button>
    </column>
  </row>
</div>
